import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
}
const Input = forwardRef<HTMLInputElement, InputProps>(({
  className,
  type,
  icon,
  ...props
}, ref) => {
  return <div className="relative" data-id="element-94">
        {icon && <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" data-id="element-95">
            {icon}
          </div>}
        <input type={type} className={cn('flex h-12 w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-slate-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-coral focus-visible:border-transparent disabled:cursor-not-allowed disabled:opacity-50 transition-all', icon && 'pl-10', className)} ref={ref} {...props} data-id="element-96" />
      </div>;
});
Input.displayName = 'Input';
export { Input };